<template>
  <div class="set-title">
    <el-dialog
      title="修改状态"
      :visible="true"
      @close="handleClose"
      width="460px"
    >
      <el-form ref="form" :model="form" label-width="80px" size="small">
        <el-form-item label="状态：">
          <div v-if="this.row.containerState == 9 || this.row.containerState == 1 || this.row.containerState == 2">
            <el-select v-model="form.containerState" placeholder="请选择状态">
              <el-option label="盘点完" value="8"></el-option>
            </el-select>
          </div>
          <div v-else>
            <el-select v-model="form.containerState" placeholder="请选择状态">
              <el-option label="盘点完" value="8"></el-option>
  <!--            <el-option label="待发账单" value="9"></el-option>
              <el-option label="待支付" value="1"></el-option>
              <el-option label="待传发票" value="2"></el-option>
              <el-option label="待发送" value="3"></el-option>-->
              <el-option label="已发送" value="4"></el-option>
              <el-option label="已取消" value="5"></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="handleClose">关闭</el-button>
        <el-button class="form-btn btn-blue" @click="doConfirm">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "set-status",
    props: {
      row: {
        type: Object,
        default: ()=>({})
      }
    },
    data(){
      return{
        form: {
          containerState: ''
        }
      }
    },
    created() {
      // this.form.containerState = this.row.containerState
      if (this.row.containerState == 9 || this.row.containerState == 1 || this.row.containerState == 2) {
        this.form.containerState = '';
      } else {
        this.form.containerState = this.row.containerState;
      }
    },
    methods: {
      async doConfirm(){
        const params = {
          id: this.row.id,
          containerState: this.form.containerState,
        }
        const res = await this.$http.get('container/updateState', {params})
        if (res.data.code === 200) {
          this.$options.confirm(true)
        }else {
          this.$message.error(res.message)
        }
      },
      handleClose () {
        this.$options.cancel('cancel')
      }
    }
  }
</script>

<style scoped lang="less">
  .set-title {
    ::v-deep .el-dialog__header {
      text-align: center;
    }
    ::v-deep .el-dialog__body{
      padding-top: 10px;
    }
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
    }
    ::v-deep .el-input-number--medium {
      width: 100%;
    }
    ::v-deep .el-input-number.is-without-controls .el-input__inner {
      text-align: left;
    }
    .w100{
      width: 100%;
      position: relative;
      span{
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
    .w50{
      display: flex;
      width: 49%;
      position: relative;
      span{
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
  }
</style>
